import { useStats } from "../hooks/useStats.ts";
import { formatNumber } from "../lib/format.ts";

export function StatsBar() {
  const { stats, loading } = useStats();

  if (loading || !stats) return null;

  return (
    <div className="flex items-center justify-center gap-6 py-6 text-xs text-text-secondary font-mono">
      <span>
        <span className="text-text-primary font-medium">{formatNumber(stats.total_projects)}</span> projects
      </span>
      <span className="text-text-muted">|</span>
      <span>
        <span className="text-text-primary font-medium">{stats.total_categories}</span> categories
      </span>
      <span className="text-text-muted">|</span>
      <span>
        <span className="text-text-primary font-medium">{stats.languages.length}</span> languages
      </span>
    </div>
  );
}
